module.exports = __webpack_public_path__ + "img/hot.728435bc.png";